import 'css-chunk:src/app/containers/Home/OrganizationsView/ClientGroup/EditClientGroupDrawer.scss';export default {
  "EditClientGroupDrawer": "_EditClientGroupDrawer_185m9_1",
  "form": "_form_185m9_1",
  "submitButton": "_submitButton_185m9_1"
};